interface BasePlan {
    name: string;
    description: string;
    items: {label:string,detailed:string}[];
    badge?: string;
  }
  
  export class SubscriptionPlan implements BasePlan {
    name: string;
    description: string;
    items: {label:string,detailed:string}[];
    badge?: string;
    originalPrice: string;
    discountedPrice: number;
  
    constructor(
      name: string,
      description: string,
      items: {label:string,detailed:string}[],
      originalPrice: string,
      discountedPrice: number,
      badge?: string
    ) {
      this.name = name;
      this.description = description;
      this.items = items;
      this.originalPrice = originalPrice;
      this.discountedPrice = discountedPrice;
      this.badge = badge;
    }
  }
  
  const basePlans: BasePlan[] = [
    {
      name: "Pro",
      description: "Perfect for individual teachers and students",
      items: [
        {label:"Unlimited Simulation Access",detailed:"Unlimited access to our prebuilt simulations"},
        {label:"500 AI Credits",detailed:"These can be used to access AI Tools"},
        {label:"Basic Customer Support",detailed:"Email And whatsapp customer support"}
      ],
    },
    {
      name: "Pro plus",
      description: "Designed for Institutes With multiple teachers",
      items: [
        {label:"Unlimited Simulation Access",detailed:"Unlimited access to our prebuilt simulations"},
        {label:"1500 AI Credits",detailed:"These can be used to access AI Tools"},
        {label:"Premium Customer Support",detailed:"Call customer Support"}
      ],
      badge: "Most Popular",
    },
    {
      name: "Premium",
      description: "Ideal for Institutes with Multiple branches.",
      items: [
        {label:"Unlimited Simulation Access",detailed:"Unlimited access to our prebuilt simulations"},
        {label:"5000 AI Credits",detailed:"These can be used to access AI Tools"},
        {label:"Dedicated Relationship Manager",detailed:"Will get a dedicated person for support"}
      ],
    },
  ];
  
  const subscriptionPeriods = [
    {
      type: "monthly",
      pricing: [
        { originalPrice: "₹3000", discountedPrice: 1200 },
        { originalPrice: "₹5000", discountedPrice: 3500 },
        { originalPrice: "", discountedPrice: 0 }, // Premium has no pricing mentioned
      ],
    },
    {
      type: "quarterly",
      pricing: [
        { originalPrice: "₹9000", discountedPrice: 3300 },
        { originalPrice: "₹15000", discountedPrice: 7000 },
        { originalPrice: "", discountedPrice: 0 },
      ],
    },
    {
      type: "yearly",
      pricing: [
        { originalPrice: "₹36000", discountedPrice: 12000 },
        { originalPrice: "₹60000", discountedPrice: 24000 },
        { originalPrice: "", discountedPrice: 0 },
      ],
    },
  ];
  


  export const VIGNAMSUBSCRIPTIONS: Record<string, SubscriptionPlan[]> = {};
  
  subscriptionPeriods.forEach(({ type, pricing }) => {
    VIGNAMSUBSCRIPTIONS[type] = basePlans.map((plan, index) =>
      new SubscriptionPlan(
        plan.name,
        plan.description,
        plan.items,
        pricing[index].originalPrice,
        pricing[index].discountedPrice,
        plan.badge
      )
    );
  });
  
